var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.b,.c{stroke:currentColor;stroke-linejoin:round;stroke-width:1.5px;}.c{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-558 -4454)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(558 4454)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26 -58)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(585 4513)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13,
    height: 13,
    rx: 2.5,
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M61.532,50.255h0A2.262,2.262,0,0,0,59.277,48h-8.7A2.585,2.585,0,0,0,48,50.578v8.7a2.262,2.262,0,0,0,2.255,2.255h.322",
    transform: "translate(-48 -48)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate-icon.2fd5e60e7a32aa4403a6e0f8e6a21938.svg";
export { ForwardRef as ReactComponent };